import { useState } from 'react';

import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { getDecodedBootstrappedLaunchDarklyFlags } from '../../global/splash/launch-darkly-init';

export const useEnableClientCommonStepUpAuth = (): boolean => {
  const [isEnabled] = useState(() => {
    const flags = getDecodedBootstrappedLaunchDarklyFlags();
    return Boolean(flags?.[FeatureFlagDeclarations.enableClientCommonStepUpAuth.key]);
  });
  return isEnabled;
};
